import { registerIcon } from "@ui5/webcomponents-base/dist/SVGIconRegistry.js";

const name = "navigation-up-arrow";
const pathData = "M86.5 380q-9 9-22.5 9t-22.5-9q-10-10-10-23t10-23l193-197q4-2 5-3 2-1 2.5-1.5t2.5-1.5q6-2 11-2 2 0 3 .5t2 .5q4 0 6 1t3.5 2 3.5 2q1 1 1.5 1t1.5 1 2 1l192 196q10 10 10 23t-10 23q-9 9-22.5 9t-22.5-9l-154-155q-16-10-32 0z";
const ltr = false;
const collection = "SAP-icons";

registerIcon(name, { pathData, ltr, collection});

export default { pathData };